/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div class="slide-control__element fullscreen-overlay__buy m0"><div class="fullscreen-overlay-inner"><span class="fullscreen-overlay-price heading-2 block mb10">';
    if (context.sale_price) {
      __p += '<del>' +
        ((__t = (context.price)) == null ? '' : _.escape(__t)) +
        '</del><span class="price sale">' +
        ((__t = (context.sale_price)) == null ? '' : _.escape(__t)) +
        '</span>';
    } else {
      __p += '' +
        ((__t = (context.price)) == null ? '' : _.escape(__t)) +
        '';
    }
    __p += '</span><span class="fullscreen-overlay-retailer block mb15">At ' +
      ((__t = (context.name)) == null ? '' : __t) +
      '</span><a href="' +
      ((__t = (context.url)) == null ? '' : _.escape(__t)) +
      '" class="btn btn--full-width" target="_blank" is="lead-link" reason="fullscreen-overlay-button">buy</a></div></div>';
    return __p;
  }
});